import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { getPortfolioDataThunk, postPortfolioDataThunk } from './portfolioThunk'

const initialState = {
	portfolioData: null,
}

export const postPortfolioData = createAsyncThunk('user/getWithdrawlRequestData', postPortfolioDataThunk)
export const getPortfolioData = createAsyncThunk('user/getPortfolioData', getPortfolioDataThunk)

export const portfolioSlice = createSlice({
	name: 'portfolio',
	initialState,
	reducers: {
		// setUserProfileData: (state, action) => {
		// 	state.profileData = action.payload
		// },
	},
	extraReducers: (builder) => {
		builder.addCase(getPortfolioData.fulfilled, (state, action) => {
			state.portfolioData = action?.payload?.data?.data
		})
	},
})
// export const {} = teamsSlice.actions
export default portfolioSlice.reducer
